import { render, staticRenderFns } from "./yek-tyoskentelyjakso-form.vue?vue&type=template&id=0cba9a82&scoped=true&"
import script from "./yek-tyoskentelyjakso-form.vue?vue&type=script&lang=ts&"
export * from "./yek-tyoskentelyjakso-form.vue?vue&type=script&lang=ts&"
import style0 from "./yek-tyoskentelyjakso-form.vue?vue&type=style&index=0&id=0cba9a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba9a82",
  null
  
)

export default component.exports